<script setup lang="ts">
import { Bot, Banknote, ChartColumn, MessageCircleMore } from 'lucide-vue-next';

import { BLACKLISTED_EMAILS } from '~/config/blacklist';

const authStore = useAuthStore();
const chatsStore = useChatStore();
const { selectedChat } = storeToRefs(chatsStore);
</script>

<template>
  <div class="hidden min-w-[132px] flex-col justify-between border-r bg-white p-2 shadow-md md:flex">
    <div>
      <CompanySelector />

      <hr>

      <div class="flex flex-col gap-2 py-4">
        <NuxtLink
          :to="{ name: 'chats-id', params: { id: selectedChat?.uuid } }" class="outline-none" tabindex="-1"
          active-class="*:bg-black/10 *:hover:bg-black/10!"
        >
          <SBButton variant="ghost" :lucide-icon="MessageCircleMore" :label="$t('nav.chats')" />
        </NuxtLink>

        <NuxtLink
          v-if="authStore.user?.email && !BLACKLISTED_EMAILS.includes(authStore.user.email)"
          :to="{ name: 'agents' }" class="outline-none" tabindex="-1"
          active-class="*:bg-black/10 *:hover:bg-black/10!"
        >
          <SBButton variant="ghost" :lucide-icon="Bot" :label="$t('nav.agents')" />
        </NuxtLink>

        <NuxtLink
          :to="{ name: 'analytics' }" class="outline-none" tabindex="-1"
          active-class="*:bg-black/10 *:hover:bg-black/10!"
        >
          <SBButton variant="ghost" :lucide-icon="ChartColumn" :label="$t('nav.analytics')" />
        </NuxtLink>

        <NuxtLink
          :to="{ name: 'billing' }" class="outline-none" tabindex="-1"
          active-class="*:bg-black/10 *:hover:bg-black/10!"
        >
          <SBButton variant="ghost" :lucide-icon="Banknote" :label="$t('nav.billing')" />
        </NuxtLink>
      </div>
    </div>

    <div class="flex flex-col self-center gap-2">
      <LanguageSwitcher />
      <SBButton variant="ghost" :label="$t('nav.logout')" @click="authStore.logout()" />
    </div>
  </div>
</template>
